import { render, staticRenderFns } from "./TopicAssistantResultWorkBench.vue?vue&type=template&id=9311f60a&scoped=true"
import script from "./TopicAssistantResultWorkBench.vue?vue&type=script&lang=js"
export * from "./TopicAssistantResultWorkBench.vue?vue&type=script&lang=js"
import style0 from "./TopicAssistantResultWorkBench.vue?vue&type=style&index=0&id=9311f60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9311f60a",
  null
  
)

export default component.exports